<template>
  <div class="publication">
    <!-- <AntPolySkeleton height="15rem" :num="8" :rows="8" :gutter="80" :loading="loading">
      <Swipers :data="data" :submit="submit" additionClass="publication_key" />
    </AntPolySkeleton> -->
    <AntGridSkeleton height="15rem" :num="8" :rows="1" :gap="1" :loading="loading">
      <Swipers :data="data" :submit="submit" additionClass="publication_key" />
    </AntGridSkeleton>
  </div>
</template>

<script>
import Swipers from '../swiper';
import { t } from '@/locales';
export default {
  components: { Swipers },
  data() {
    return {
      loading: true,
      data: []
    }
  },
  created() {
    this.getData();
  },
  methods: {
    t,
    submit(data = {}) {
      this.$FN.limitsTips({ list: ["home_publication_details"] }).then(res => {
        if (res) {
          // this.$router.$push({ path: "container", query: { url: `${this.$FN.iframeUrl}/npg/stdsearch/stdsearch_detail?sid=${data.id}` } })

          let form = {
            id: this.$FN.check(data, "id"),
            oneRoute: JSON.stringify({ backUrl: "/standardTranslation", title: t('home.publicationTitle') })
          }
          window.open(`${window.location.origin}/detailsPage/standardDetail?${this.$FN.removeEmpty(form, 'string')}`);

          // this.$router.$push({
          //   path: "/detailsPage/standardDetail",
          //   query: {
          //     id: this.$FN.check(data, "id"),
          //     oneRoute: JSON.stringify({ backUrl: "/standardTranslation", title: "中国标准英文版出版物" })
          //   }
          // })
        }
      });
    },
    getData() {
      this.$FN.get("api/product_service/standard/transList").then(res => {
        this.loading = false;
        if (res) {
          let { entity = [] } = res;
          if (entity) this.data = entity.map(item => ({ ...item, name: item.stdName, img: item.coverImg ? `${this.$FN.publicUrl}${item.coverImg}` : require("@/assets/images/public/no_img.png") }));
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>